// Project data. `links` is optional — add { live, appStore, playStore, github }
// per project and the ProjectCard will render glass link-buttons automatically.
export const projects = [
  {
    id: 'wovvii',
    title: 'Wovvii',
    number: '01',
    tagline: 'Food delivery platform · Founder',
    description: (
      <>
        <p>
          <strong>Wovvii</strong> is a food delivery platform I founded and built
          end-to-end, launched in Bangalore with a focus on giving customers better value
          and restaurants a fairer deal.
        </p>
        <div className="tech-item">
          <span className="tech-label">Customer App (Flutter):</span> End-to-end ordering
          with real-time order tracking, live driver location, multi-restaurant checkout,
          and WhatsApp OTP login.
        </div>
        <div className="tech-item">
          <span className="tech-label">Driver App (Flutter):</span> Real-time dispatch with
          slide-to-accept, multi-stop group delivery, COD with OTP verification, and live
          navigation.
        </div>
        <div className="tech-item">
          <span className="tech-label">Backend (Python / FastAPI):</span> Async REST API and
          WebSocket dispatch engine with prep-time-aware order dispatch and OSRM
          road-distance pricing.
        </div>
        <div className="tech-item">
          <span className="tech-label">Restaurant Dashboard (Next.js):</span> Order
          management portal with POS integration for menu sync and real-time availability
          updates.
        </div>
      </>
    ),
    techStack: ['Flutter', 'Python', 'FastAPI', 'Next.js', 'WebSocket', 'OSRM', 'Firebase'],
    imageClass: 'wovvii-placeholder',
    links: {},
  },
  {
    id: 'baymax',
    title: 'Baymax',
    number: '02',
    tagline: 'AI personal assistant robot',
    description: (
      <>
        <p>
          <strong>Baymax</strong> is an AI-powered personal assistant robot inspired by Big
          Hero 6, designed with a modular architecture that blends robotics and artificial
          intelligence.
        </p>
        <div className="tech-item">
          <span className="tech-label">Raspberry Pi</span> (Controller): Interfaces with an
          Arduino, which drives the motors via a motor driver. It also manages sensors,
          camera input, and initial voice-to-text conversion.
        </div>
        <div className="tech-item">
          <span className="tech-label">Arduino</span> (Motion Control): Executes precise
          motor control commands from the Raspberry Pi for physical movement and navigation.
        </div>
        <div className="tech-item">
          <span className="tech-label">Laptop</span> (AI Brain): Runs a large language model
          (LLM) with optical vision for visual understanding, processes user input, and
          sends responses or movement commands back to the Raspberry Pi through API calls.
        </div>
        <div className="tech-item">
          <span className="tech-label">Voice Recognition:</span> Enables natural
          interaction, allowing users to issue commands (e.g., movement, assistance tasks)
          directly through speech.
        </div>
      </>
    ),
    techStack: ['Raspberry Pi', 'Arduino', 'Python', 'LLM', 'Computer Vision', 'Voice AI'],
    imageClass: 'baymax-placeholder',
    links: {},
  },
  {
    id: 'desty-besty',
    title: 'Desty Besty',
    number: '03',
    tagline: 'Social travel community',
    description: (
      <p>
        <strong>Desty Besty</strong> is more than a travel guide – it's a social community
        for explorers. On the Home feed, travelers can share their journeys, post photos,
        and inspire others with unique experiences. The Explore page helps you discover
        undiscovered locations, amazing cafés, and hidden restaurants around you. Whether
        you're seeking offbeat adventures or simply want to connect with like-minded
        explorers, Desty Besty makes traveling more social, fun, and authentic.
      </p>
    ),
    techStack: ['Flutter', 'Cloud Database', 'Cloud Functions'],
    imageClass: 'desty-besty-placeholder',
    links: {},
  },
  {
    id: 'habit-it',
    title: 'Habit It',
    number: '04',
    tagline: 'All-in-one productivity app',
    description: (
      <p>
        <strong>Habit It</strong> is your all-in-one productivity companion — track habits,
        manage finances, plan your day, and stay focused with built-in timers and reminders.
        Stay organized, motivated, and in control — all in one beautifully designed app.
      </p>
    ),
    techStack: ['Flutter', 'Provider', 'Local Storage', 'RevenueCat'],
    imageClass: 'habit-it-placeholder',
    hasPrivacyLink: true,
    links: {},
  },
  {
    id: 'citizen-carz',
    title: 'Citizen Carz',
    number: '05',
    tagline: 'Second-hand car marketplace',
    description: (
      <p>
        <strong>Citizen Carz</strong> is the official app of the city's best second-hand car
        showroom. Browse a wide collection of pre-owned cars with complete details, photos,
        and pricing – all in one place. Whether you're looking to buy your first car, upgrade
        to a better model, or find a budget-friendly ride, Citizen Carz makes the process
        simple and transparent.
      </p>
    ),
    techStack: ['Flutter', 'Cloud Database', 'Cloud Functions'],
    imageClass: 'citizen-carz-placeholder',
    links: {},
  },
];
